
import { useCollectionRealtime } from './realtime/useCollectionRealtime';

/**
 * Hook to set up real-time subscription for country updates using Universal Real-time Manager
 * @param refreshCallback Function to call when countries are updated
 */
export const useCountryRealtime = (
  refreshCallback: () => Promise<void>
) => {
  const { isConnected, connectionStatus } = useCollectionRealtime(
    'users', // Using 'users' collection type as it can monitor countries table
    {}, // No specific filters
    {
      onItemAdded: async () => {
        console.log('Country added, refreshing...');
        await refreshCallback();
      },
      
      onItemUpdated: async () => {
        console.log('Country updated, refreshing...');
        await refreshCallback();
      },
      
      onItemRemoved: async () => {
        console.log('Country removed, refreshing...');
        await refreshCallback();
      },
      
      onError: (error) => {
        console.error('Country real-time error:', error);
      }
    },
    true // Always enabled
  );

  return {
    subscriptionStatus: connectionStatus,
    isConnected
  };
};
